import { render } from "./IntegrationImportantDataSettings.vue?vue&type=template&id=16525b5b"
import script from "./IntegrationImportantDataSettings.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./IntegrationImportantDataSettings.vue?vue&type=script&charset=utf-8&lang=js"

import "./IntegrationImportantDataSettings.vue?vue&type=style&index=0&id=16525b5b&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__